/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-divider{border-bottom:1px solid #e0e0e0}.mat-expansion-panel-header-title{margin-right:0}.mat-expansion-panel-header-description{justify-content:flex-end;margin-right:0;align-items:flex-end}@media screen and (max-width:599px){.mat-expansion-panel-header-description{font-size:12px}}.contacts-table{flex:1 1 auto;max-height:500px;overflow:auto!important}"];
export { styles as styles };
